<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="管理附件"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="65%"
    @beforeopen="onOpen"
  >
    <el-form :model="item" ref="itemform" label-width="150px" :rules="rules">
      <el-form-item label="文件上传" prop="file">
        <el-upload
          ref="upload"
          accept=".zip"
          :action="uploadUrl"
          :headers="uploadHeader"
          :file-list="fileList"
          :auto-upload="false"
          :on-success="handleSuccess"
          :on-error="handleError"
          :on-remove="handleRemove"
          :on-preview="handlePreview"
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem('jwtToken')}`,
        Accept: 'application/json',
      },
      uploadUrl: 'api/ipc/upload',
      // log: '',
      items: [],
      submitting: false,
      item: {},
      fileList: [],
      removeList: [],
      rules: {
        // VerNumber: [
        //   { required: true, message: '版本号', trigger: 'blur' },
        // ],
        // UpdateLog: [
        //   { required: true, message: '更新日志', trigger: 'blur' },
        // ],
      },
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        // imagelink: true, // 图片链接
        // code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        // readmodel: true, // 沉浸式阅读
        // htmlcode: true, // 展示html源码
        // /* 1.3.5 */
        // undo: true, // 上一步
        // redo: true, // 下一步
        // trash: true, // 清空
        // /* 1.4.2 */
        // navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        // preview: true, // 预览
      },
    };
  },
  methods: {
    onOpen() {
      this.item = this.value;
      if (this.item.Attachments) {
        this.value.Attachments.forEach((ele) => {
          const file = {};
          file.id = ele.ID;
          file.name = ele.Name;
          file.url = ele.Url;
          this.fileList.push(file);
        });
      } else {
        this.item.Attachments = [];
      }
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.fileList = [];
      this.removeList = [];
      this.$refs.itemform.resetFields();
      this.$refs.upload.clearFiles();
      this.submitting = false;
      this.preurl = '';
      this.funurl = '';
      this.item = {};
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        // console.log(this.$refs.upload.uploadFiles)
        if(this.$refs.upload.uploadFiles.length==0){
          this.$message({
            type: "warning",
            message: "请上传附件",
            duration: 1500,
          });
          return;
        }
        this.submitting = true;
        if (this.$refs.upload.uploadFiles.findIndex(item => item.status === 'ready') >= 0) {
          this.$refs.upload.submit();
        } else {
          this.lastSubmit();
        }
      });
    },
    handleSuccess(response) {
      this.item.Attachments.push(response);
      this.lastSubmit();
    },
    handleRemove(file) {
      if (file.status === 'success') {
        this.removeList.push(file.url);
      }
    },
    handlePreview(file) {
      const a = document.createElement('a');
      a.setAttribute('download', file.name);
      a.setAttribute('href', file.url);
      a.click();
    },
    lastSubmit() {
      if (this.removeList.length !== 0) {
        this.removeList.forEach((ele) => {
          this.item.Attachments.splice(this.item.Attachments.findIndex(item => item.Url === ele), 1);
        });
        this.$axios.delete('ipc/dispose', { data: { file: this.removeList } });
      }
      this.$axios.put(`software/version/attachment/${this.value.ID}`, this.item).then(() => {
        this.$message({
          message: '上传成功!',
          type: 'success',
        });
        this.onClose();
        this.$emit('form:saved');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.submitting = false;
      });
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
  },
};
</script>
